import React, { useState, useEffect } from 'react'
import { Redirect, withRouter, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../../../constantes/routes'
import { specialtiesActions } from '../../../actions/specialtiesActions'
import NewSpecialtiesModal from './NewSpecialtiesModal'
import SpecialtiesList from './SpecialtiesList'
import PlusBtn from '../../buttons/PlusBtn'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { onSubmitText } from '../../../constantes/onSubmitText'
import EditSpecialtiesModal from './EditSpecialtiesModal'
import Search from '../../common/Search'
import Header from '../../header/Header'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { specialtiesTypes } from '../../../constantes/actionTypes'
import validators from '../../../utils/validationsRegEx'

const SpecialtiesContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const allSpecialties = useSelector((state) => state.specialties)

  const [newSpecialties, setNewSpecialties] = useState('')
  const [editSpecialty, setSpecialty] = useState('')
  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  const [items, setItems] = useState(allSpecialties)

  const dispatch = useDispatch()
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())
  const newSpecialty = (specialty) =>
    dispatch(specialtiesActions.newSpeciality(specialty))
  const editSpecialties = (specialty) =>
    dispatch(specialtiesActions.updateSpeciality(specialty))
  const deleteSpeciality = (idSpeciality) =>
    dispatch(specialtiesActions.deleteSpeciality(idSpeciality))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllSpecialties()
    }
  }, [])

  useEffect(() => {
    setItems(allSpecialties)
  }, [allSpecialties])

  const openNewModal = () => {
    setIsOpen({
      createModal: true,
      editModal: false,
    })
  }

  const openEditModal = (specialty) => {
    setIsOpen({
      createModal: false,
      editModal: true,
    })
    setSpecialty(specialty)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const response = await newSpecialty(newSpecialties) // await specialtiesApi.newSpecialties({ nombre: newSpecialties })
      if (response.type === specialtiesTypes.NEW_SPECIALTY_SUCCESS) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
        setNewSpecialties({})
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const handleSubmitToUpdate = async (event) => {
    try {
      event.preventDefault()
      const response = await editSpecialties(editSpecialty) //await specialtiesApi.updateSpecialties(specialyty)
      if (response.type === specialtiesTypes.UPDATE_SPECIALTY_SUCCESS) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const handleRemove = async (idSpeciality) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar esta especialidad?',
      )
      if (alert.isConfirmed) {
        const response = await deleteSpeciality(idSpeciality)
        if (response.type === specialtiesTypes.DELETE_SPECIALTY_SUCCESS) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
        }
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const handleChange = (e) => {
    const value = e.target.value
    const name = e.target.name
    setNewSpecialties({ [name]: value })
  }

  const handleChangeEditSpeciality = (e) => {
    const value = e.target.value
    const name = e.target.name
    setSpecialty((x) => ({ ...x, [name]: value }))
  }

  const validateFormNew = () => {
    return validators.hasValue(newSpecialties.nombre)
  }

  const validateFormEdit = () => {
    return validators.hasValue(editSpecialty.nombre)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allSpecialties.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header text={'Especialidades'} route={toBackoffice} backBtn={true} />
          <div className='filter__wrap mb-80'>
            <Search
              onChangeSearch={onChangeSearch}
              placeholder='Buscar por nombre...'
            />
            <div className='add__action__rigth__side'>
              <button className='action-button' onClick={openNewModal}>
                <PlusBtn />
                <span>Nueva especialidad</span>
              </button>
            </div>
          </div>
          <SpecialtiesList
            allSpecialties={items}
            handleRemove={handleRemove}
            userProfile={userProfile}
            openEditModal={openEditModal}
          />
          <NewSpecialtiesModal
            newSpecialties={newSpecialties}
            modalIsOpen={modalIsOpen.createModal}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            validateForm={validateFormNew}
            textBtn={onSubmitText.Crear}
          />
          <EditSpecialtiesModal
            editSpecialty={editSpecialty}
            modalIsOpen={modalIsOpen.editModal}
            closeModal={closeModal}
            handleSubmitToUpdate={handleSubmitToUpdate}
            handleChange={handleChangeEditSpeciality}
            validateForm={validateFormEdit}
            textBtn={onSubmitText.Guardar}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}
export default withRouter(SpecialtiesContainer)
